import type { LinePool } from "../ui/companion/machine.ts";

/** English twin of `companion.vi.ts`: same moods, same warmth, no mocking. */
export const COMPANION_LINES_EN: Record<LinePool, readonly string[]> = {
  start: [
    "Let's beat this level together, I am cheering my heart out!",
    "Ready? I am sitting right here waiting to watch you shine!",
    "A new level! Take your time and have fun.",
    "I brought a whole basket of luck for you!",
    "Take a deep breath, then let's go!",
  ],
  combo: [
    "Wow, right after right! You are amazing!",
    "Do your hands know magic? You keep getting it right!",
    "What a streak! Keep it up!",
    "I have been clapping so hard my hands hurt!",
    "Quick and neat, totally perfect!",
  ],
  bin: [
    "One more spot done! So tidy!",
    "Another neat corner, super cool!",
    "All full! I love it!",
  ],
  phase: [
    "Ooh, something just changed! Take a closer look!",
    "The magic just switched on! Check the new rule!",
  ],
  oops: [
    "Just a tiny miss, no big deal!",
    "Oops, not that spot. Try another one!",
    "Off by a little, I still believe in you!",
  ],
  oopsAgain: [
    "Take a deep breath, then we try again.",
    "Slow and steady, look closely before you drop it.",
    "I mix things up all the time too, don't worry!",
  ],
  cry: [
    "Sniff, I feel for you. Take a little break and try again!",
    "It's okay, after a few mistakes the right one always comes!",
    "I'll just cry a tiny bit, then we keep going together!",
  ],
  comeback: [
    "There you go! That's it, I knew it!",
    "You're back in the groove! Awesome!",
    "See? You can do it!",
  ],
  undo: [
    "One step back to jump further!",
    "Thinking again is fine, thinking hard wins!",
  ],
  hint: [
    "Let me peek, right here!",
    "The bulb is on! Follow the sparkle.",
  ],
  sleepy: [
    "Yawn, hey friend, I am so sleepy.",
    "I'll take a tiny nap, wake me up if you need me.",
    "Cooking up a clever plan? I'll wait.",
  ],
  wake: [
    "Ah, I'm awake! Let's keep going!",
    "Did I doze off? Hehe, let's play on!",
  ],
  win3: [
    "Perfect! Are you a genius or what?",
    "Three shiny stars! I am so proud of you!",
    "Top of the top! Let's take three stars home!",
  ],
  win: [
    "Done! Next time we grab more stars!",
    "Level cleared! You're so good!",
    "Phew, we did it! I'm so happy!",
  ],
  poke: [
    "Hehe, that tickles!",
    "I'm right here, need anything?",
    "Stop poking me, focus on the game!",
    "Go go go, I'm cheering for you!",
  ],
};

export const companionEn = {
  settingLabel: "Buddy in levels",
  settingNote: "Your character sits in the corner of the screen and shares every up and down with you.",
  pokeLabel: "Your buddy",
};
